export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7099.9b9dd028.jpg";